/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploader_DropInputs */

const en_common_uploader_drop = /** @type {(inputs: Common_Uploader_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop to upload`)
};

const zh_common_uploader_drop = /** @type {(inputs: Common_Uploader_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拖放以上传`)
};

/**
* | output |
* | --- |
* | "Drop to upload" |
*
* @param {Common_Uploader_DropInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_drop = /** @type {((inputs?: Common_Uploader_DropInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_DropInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_drop(inputs)
	return zh_common_uploader_drop(inputs)
});
export { common_uploader_drop as "common.uploader.drop" }